import { render, staticRenderFns } from "./BaseIcon.vue?vue&type=template&id=3e8c6cd8&"
import script from "./BaseIcon.vue?vue&type=script&lang=js&"
export * from "./BaseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e8c6cd8')) {
      api.createRecord('3e8c6cd8', component.options)
    } else {
      api.reload('3e8c6cd8', component.options)
    }
    module.hot.accept("./BaseIcon.vue?vue&type=template&id=3e8c6cd8&", function () {
      api.rerender('3e8c6cd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/BaseIcon.vue"
export default component.exports